import { ComponentType, lazy } from 'react';

type ImportComponent = () => Promise<{ default: ComponentType }>;

// Prevents from 'Loading chunk failed' error after new version of the application is deployed
// Context: https://rollbar.com/blog/javascript-chunk-load-error/
// Credits: https://gist.github.com/raphael-leger/4d703dea6c845788ff9eb36142374bdb
const lazyWithRetry = (componentImport: ImportComponent) =>
  lazy((async () => {
    const pageHasAlreadyBeenForceRefreshed: boolean = JSON.parse(
      localStorage.getItem('page-has-been-force-refreshed') || 'false'
    );

    try {
      localStorage.setItem('page-has-been-force-refreshed', 'false');
      return await componentImport();
    } catch (error) {
      if (
        typeof error === 'object' &&
        error !== null &&
        'name' in error &&
        typeof error.name === 'string' &&
        /ChunkLoadError/.test(error.name) &&
        !pageHasAlreadyBeenForceRefreshed
      ) {
        // Assuming that the user is not on the latest version of the application.
        // Let's refresh the page immediately.
        localStorage.setItem('page-has-been-force-refreshed', 'true');
        window.location.reload();
        return;
      }
      // The page has already been reloaded
      // Assuming that user is already using the latest version of the application.
      // Let's let the application crash and raise the error.
      throw error;
    }
  }) as ImportComponent);

export default lazyWithRetry;
